<template>
    <v-img
        :src="logo"
        :min-width="size"
        :width="size"
        :max-width="size"
        :min-height="size"
        :height="size"
        :max-height="size"
        contain
        :style="color"
    />
</template>

<script>
import appInfo from '@/helper/appInfo'
import colorizer from "@/helper/colorizer";

export default {
    name: "SpoiledLogo",
    props: {
        size: {
            required: true,
        },
    },
    computed: {
        color() {
          return colorizer.compute(appInfo.config.primary);
        },
        logo() {
            return require('@/assets/logo.webp');
        },
    },
}
</script>

<style scoped>

</style>